export default __webpack_public_path__ + "static/media/mpvertical.3f9d4eaa.jpeg";